import React, { useState, useRef, useEffect } from 'react'
import './EmojiPicker.scss'

const EMOJI_CATEGORIES = [
  {
    label: '😀',
    name: 'Смайлы',
    emojis: ['😀','😁','😂','🤣','😃','😄','😅','😆','😉','😊','😋','😎','😍','🥰','😘','😗','😙','😚','🙂','🤗','🤩','🤔','🤨','😐','😑','😶','🙄','😏','😣','😥','😮','🤐','😯','😪','😫','🥱','😴','😌','😛','😜','😝','🤤','😒','😓','😔','😕','🙃','🤑','😲','😷','🤒','🤕','🤢','🤮','🥴','🥵','🥶','🤧','😵','🤯','🤠','🥳','😈','👿','👹','👺','💀','☠️','👻','👽','🤖','💩','😺','😸','😹','😻','😼','😽','🙀','😿','😾'],
  },
  {
    label: '👋',
    name: 'Люди',
    emojis: ['👋','🤚','🖐','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🙏','✍️','💅','🤳','💪','🦵','🦶','👂','🦻','👃','🧠','👀','👁','👅','🦷','🗣','👤','👶','🧒','👦','👧','🧑','👱','👩','🧔','👴','👵','🙍','🙎','🙅','🙆','💁','🙋','🧏','🙇','🤦','🤷'],
  },
  {
    label: '❤️',
    name: 'Сердца',
    emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','☮️','✝️','☯️','🕉','☪️','🛐','♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓','⛎','🔯','🆔','⚜️','🔰','♻️','✅','🆑','🆒','🆓','🆕','🆖','🆗','🆘','🆙','🆚','🈁','🈶','🈯','🉐','🈹','🈚','🈲','🉑','🈸','🈴','🈳','㊗️','㊙️','🈺','🈵'],
  },
  {
    label: '🐶',
    name: 'Животные',
    emojis: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐒','🦆','🐧','🐦','🐤','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🐛','🦋','🐌','🐞','🐜','🦟','🦗','🕷','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠','🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍','🦧','🦣','🐘','🦏','🐪','🐫','🦒','🦘','🦬','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🐐','🦌'],
  },
  {
    label: '🍕',
    name: 'Еда',
    emojis: ['🍕','🍔','🍟','🌭','🍿','🧂','🥓','🥚','🍳','🧇','🥞','🧈','🍞','🥐','🥖','🥨','🧀','🥗','🥙','🥪','🌮','🌯','🧆','🥫','🍝','🍜','🍲','🍛','🍣','🍱','🥟','🦪','🍤','🍙','🍚','🍘','🍥','🥮','🍢','🧁','🍰','🎂','🍮','🍭','🍬','🍫','🍿','🍩','🍪','🌰','🥜','🍯','🧃','🥤','🧋','🍵','☕','🍶','🍺','🍻','🥂','🍷','🥃','🍸','🍹','🧉'],
  },
  {
    label: '⚽',
    name: 'Активности',
    emojis: ['⚽','🏀','🏈','⚾','🥎','🏐','🏉','🥏','🎾','🏸','🏒','🏑','🥍','🏏','🪃','🥅','⛳','🪁','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛼','🛷','⛸','🥌','🎿','⛷','🏂','🏋️','🤸','🤺','⛹','🤾','🏌️','🧘','🏄','🤽','🚵','🤼','🤾','🏇','🚴','🤺','🏊','🧗','🚣','🪂'],
  },
  {
    label: '🚀',
    name: 'Путешествия',
    emojis: ['🚀','✈️','🛸','🚁','⛵','🚢','🚂','🚃','🚄','🚅','🚆','🚇','🚈','🚉','🚊','🚝','🚞','🚋','🚌','🚍','🚎','🚐','🚑','🚒','🚓','🚔','🚕','🚖','🚗','🚘','🚙','🚚','🚛','🚜','🏎','🏍','🛵','🦽','🦼','🛺','🚲','🛴','🛻','🚏','🛣','🛤','⛽','🚧','⚓','⛵','🚤','🛥','🛳','⛴','🚢','🛩','✈️','🛫','🛬','🪂','💺','🚁','🚟','🚠','🚡','🛰','🚀','🛸'],
  },
  {
    label: '💡',
    name: 'Объекты',
    emojis: ['💡','🔦','🕯','🪔','💰','💴','💵','💶','💷','💸','💳','🪙','💹','📈','📉','📊','📋','📌','📍','🗺','🧭','⏳','⌛','⏰','⏱','⌚','🔔','🔕','📣','📢','🔊','🔉','🔈','🔇','📱','☎️','📞','📟','📠','🔋','🪫','🔌','💻','🖥','🖨','⌨️','🖱','💾','💿','📀','📷','📸','📹','🎥','📽','🎞','📞','☎️','🧲','🔭','🔬','🩺','💊','🩹','🩼','💉','🩸','🧬','🦠'],
  },
  {
    label: '🔥',
    name: 'Символы',
    emojis: ['🔥','⭐','🌟','✨','💥','💫','🌈','❄️','💧','🌊','🌀','🌪','🌩','⚡','☄️','🪐','🌍','🌎','🌏','🌕','🌖','🌗','🌘','🌑','🌒','🌓','🌔','🌙','🌛','🌜','🌚','🌝','🌞','⭐','🌟','💫','✨','🌠','☁️','⛅','🌤','🌥','🌦','🌧','⛈','🌩','🌨','❄️','☃️','⛄','🌬','💨','🌫','🌊','💧','💦','☔','⛱','🔆','🔅','🔱','⚜️','🏵','🎖','🏆','🥇','🥈','🥉','🎗','🎫','🎟','🎪','🤹','🎭','🎨','🎬','🎤','🎧','🎼','🎵','🎶','🎷','🎸','🎹','🥁','🎺','🎻','🪕'],
  },
]

const EmojiPicker = ({ onSelect, inline = false }) => {
  const [open, setOpen] = useState(false)
  const [activeCategory, setActiveCategory] = useState(0)
  const [search, setSearch] = useState('')
  const ref = useRef(null)

  useEffect(() => {
    if (inline) return
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [inline])

  const filteredEmojis = search
    ? EMOJI_CATEGORIES.flatMap(c => c.emojis).filter(e => e.includes(search))
    : EMOJI_CATEGORIES[activeCategory].emojis

  const handleSelect = (emoji) => {
    onSelect(emoji)
  }

  const pickerContent = (
    <div className={inline ? 'emoji-picker-inline' : 'emoji-picker-popup'}>
      <div className="emoji-picker-search">
        <input
          type="text"
          placeholder="Поиск эмодзи..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoFocus={!inline}
        />
        {!inline && (
          <button
            type="button"
            className="emoji-picker-close"
            onClick={() => { setOpen(false); setSearch(''); }}
            title="Закрыть"
          >✕</button>
        )}
      </div>

      {!search && (
        <div className="emoji-picker-categories">
          {EMOJI_CATEGORIES.map((cat, i) => (
            <button
              key={i}
              type="button"
              className={`emoji-picker-cat-btn${i === activeCategory ? ' active' : ''}`}
              onClick={() => setActiveCategory(i)}
              title={cat.name}
            >
              {cat.label}
            </button>
          ))}
        </div>
      )}

      <div className="emoji-picker-grid">
        {filteredEmojis.map((emoji, i) => (
          <button
            key={i}
            type="button"
            className="emoji-picker-item"
            onClick={() => handleSelect(emoji)}
          >
            {emoji}
          </button>
        ))}
        {filteredEmojis.length === 0 && (
          <div className="emoji-picker-empty">Ничего не найдено</div>
        )}
      </div>
    </div>
  )

  if (inline) return pickerContent

  return (
    <div className="emoji-picker-wrapper" ref={ref}>
      <button
        type="button"
        className="emoji-picker-btn"
        onClick={() => setOpen(o => !o)}
        title="Эмодзи"
      >
        😊
      </button>

      {open && pickerContent}
    </div>
  )
}

export default EmojiPicker
